// eslint-disable-next-line max-len,vue/max-len
export const TELEGRAM_BOT_LINK = 'https://refer.id/?bot=schoolsynergy_bot&platform=telegram&bot_avatar=https://getmybot.storage.yandexcloud.net/uploads/bot_avatars/photo_2025-04-11_11-47-35.jpg&n=131384&c=8689';

// export const TELEGRAM_LINKS = {};

export const getTelegramLink = (route) => {
  if (!route) return TELEGRAM_BOT_LINK;

  if (process.client) {
    return `${TELEGRAM_BOT_LINK}&url=${window.location.href}`;
  }

  return `${TELEGRAM_BOT_LINK}&url=https://school.synergy.ru${route.fullPath}`;
};

export default {
  TELEGRAM_BOT_LINK,
};
